import Utils from "../../utils/Utils";

/**
 * To sync status control pin & android playing
 * 
 * FIXME. IMPORTANT, is it a good idea to extend this obs to use in all the AAF app?
 */
function StopTrackingObserver() {
    this.handlers = []; 
    this.sendingStop = false;
    this.lastTimeSendingStop = null;
    this.params = null;
}

StopTrackingObserver.prototype = {

    getParams: function() {
        return this.params;
    },

    setParams: function(params) {
        this.params = params;
    },

    getLastTimeSendingStop: function() {
        return this.lastTimeSendingStop;
    },

    getSendingStop: function() {
        return this.sendingStop;
    },

    setSendingStop: function(sendingStop) {
        this.sendingStop = sendingStop;
        if(sendingStop) {
            this.lastTimeSendingStop = Utils.nowAsTimestampSeconds();
        }
        else {
            this.lastTimeSendingStop = null;
        }
    },

    subscribe: function(fn) {
        this.handlers.push(fn);
    },

    unsubscribe: function(fn) {
        this.handlers = this.handlers.filter(
            function(item) {
                if (item !== fn) {
                    return item;
                }
            }
        );
    },

    fire: function(o, thisObj) {
        var scope = thisObj || window;
        this.handlers.forEach(function(item) {
            item.call(scope, o);
        });
    }
}

const stopTrackingObserver = new StopTrackingObserver();

export default stopTrackingObserver;


// WEBPACK FOOTER //
// ./src/AAFPlayer/helpers/StopTrackingObserver.js